"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tab = void 0;
var tab_1 = require("./tab");
Object.defineProperty(exports, "Tab", { enumerable: true, get: function () { return tab_1.Tab; } });
